module.exports = {
      id: "audio-pause-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#audio-pause",
      toString: function () {
        return this.url;
      }
    }